module.exports = __webpack_public_path__ + "static/media/nb.4a49583e.svg";